'use client'

import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked = false, onCheckedChange, disabled, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center justify-center">
        <input
          type="checkbox"
          ref={ref}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          className="sr-only peer"
          {...props}
        />
        <div
          onClick={() => !disabled && onCheckedChange?.(!checked)}
          className={cn(
            'flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-slate-300 bg-white transition-all cursor-pointer select-none',
            'hover:border-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600',
            checked && 'border-[#0A1B4A] bg-[#0A1B4A] text-white',
            disabled && 'cursor-not-allowed opacity-50',
            className
          )}
        >
          {checked && <Check className="size-3 text-white stroke-[3]" />}
        </div>
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
